module.exports = __webpack_public_path__ + "img/6.0315e190.png";